import { render, staticRenderFns } from "./GridStrategyOverlay.vue?vue&type=template&id=196d3560&"
import script from "./GridStrategyOverlay.vue?vue&type=script&lang=ts&"
export * from "./GridStrategyOverlay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports